import { TabPanel, TabView } from "primereact/tabview";
import CustomerSalesHistory from "./CustomerSalesHistory.js";
import CustomerRemainingPackages from "./CustomerRemainingPackages.js";

const CustomerHistory = (props) => {
  const { data, loading, error, filterValue, setFilterValue } = props;

  return (
    <div className="elevated-card-tight-vertical w-full p-4 border border-gray-200 !shadow-md">
      <TabView>
        <TabPanel header="Items Purchased">
          <CustomerSalesHistory
            data={data}
            loading={loading}
            error={error}
            filterValue={filterValue}
            setFilterValue={setFilterValue}
          />
        </TabPanel>
        <TabPanel header="Remaining Packages">
          <CustomerRemainingPackages
            data={data}
            loading={loading}
            error={error}
          />
        </TabPanel>
      </TabView>
    </div>
  );
};

export default CustomerHistory;
